import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MDXComponents/MDXButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MDXComponents/MDXCodeTabs.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MDXComponents/MDXImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MDXComponents/MDXPre.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsItem"] */ "/vercel/path0/components/MDXComponents/MDXTabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MDXComponents/MDXVideo.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/layouts/Post.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
